import http from '../common/http'

export const list = (param) => {
  return http.requestPost('/project/list?page=' + param.page + '&size=' + param.size + '&type=' + (param.type || 0) + '&orderBy=' + (param.orderBy || 'create_time'), param.form);
}
export const fileList = (param) => {
  return http.requestPost('/project/fileList?page=' + param.page + '&size=' + param.size, param.form);
}
export const create = (param) => {
  return http.requestPost('/project/create', param);
}
export const update = (param) => {
  return http.requestPost('/project/update', param);
}
export const saveFile = (param) => {
  return http.requestPost('/project/saveFile', param);
}
export const cancel = (param) => {
  return http.requestPost('/project/cancel', param);
}
export const qryProject = (param) => {
  return http.requestPost('/project/qryProject', param);
}
export const qrySavedProject = () => {
  return http.requestPost('/project/qrySavedProject');
}
export const qryProjectFile = (id, type) => {
  return http.requestPost('/project/qryProjectFile?projectId=' + id + "&type=" + type);
}
export const qryProjectFee = (id) => {
  return http.requestPost('/project/qryProjectFee?projectId=' + id);
}
export const qryProjectMember = (param) => {
  return http.requestPost('/project/qryProjectMember', param);
}
export const projectMemberList = (param) => {
  return http.requestPost('/project/projectMemberList', param);
}
export const del = (id) => {
  return http.requestPost('/project/del?projectId='+id);
}
export const delFile = (id) => {
  return http.requestPost('/project/delFile?uuid='+id);
}
export const qryDetailList = (phone) => {
  return http.requestPost('/project/qryDetailList?phone='+phone);
}